import {
  Table,
  Tag,
  Space,
  PageHeader,
  Button,
  Modal,
  Col,
  Typography,
  Row,
  Form,
  Input,
} from "antd";
import { useApiContext } from "../../hooks/useApiContext";
import { dateFormat } from "../../utils/Constants";
import apis from "../../services/apis";
import { useNavigate, Link } from "react-router-dom";
import {
  TeamOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import moment from "moment";

export default function Salary() {
  const { Column } = Table;
  const { salaries, salarydispatch, user } = useApiContext();
  const [salariesData, setSalaryDate] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [getId, setGetId] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('abc ',apis.Salaries.list(salarydispatch))
    if (salaries.length < 1) apis.Salaries.list(salarydispatch);
    setSalaryDate(salaries);
  }, [salaries.length < 1]);

  const navigate = useNavigate();
  const getsearchData = (value) => {
    if (value.target.value === null) setSalaryDate(salaries);

    var getData = salaries.filter((x) => x.getEmployee.fullName.toLowerCase().includes(value.target.value.toLowerCase()));
    setSalaryDate(getData);
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setGetId(id);
  };

  const handleDelete = () => {
    setLoading(true);
    apis.Salaries.delete(salarydispatch, getId).then((res) => {
      setShowDelete(false);
      setLoading(false);
      setGetId("");
    });
  };
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Salaries"
        subTitle="Find all the list of salaries here"
        extra={
          <Button
            type="primary"
            onClick={() => navigate("/addsalary")}
            icon={<TeamOutlined />}
          >
            Add Salary
          </Button>
        }
      />
      <Typography.Title level={4}>Filters</Typography.Title>
      <Row>
        <Col span={6}>
          <Form.Item label="Enter Employee Name">
            <Input
              placeholder="Enter employee full-name here"
              onKeyUp={(e) => getsearchData(e)}
            />
          </Form.Item>
        </Col>
        {/* <Col span={6} style={{ marginLeft: "10px" }}>
          <Form.Item label="Enter Employee Id">
            <Input
              placeholder="Enter employee id here"
              // onKeyUp={(e) => getsearchDataByEmpId(e)}
            />
          </Form.Item>
        </Col> */}
      </Row>
      <Table dataSource={salariesData} rowKey={(record) => record.id}>
        <Column
          title="Employee Name."
          key="invoiceNo"
          render={(text, record) => <>{record.getEmployee.fullName}</>}
        />
        <Column
          title="Invoice Date"
          render={(text, record) => (
            <>{moment(record.paymentDate).format(dateFormat)}</>
          )}
        />

        <Column
          title="Basic Salary"
          dataIndex="basicSalary"
          key="basicSalary"
        />
        <Column
          title="Total Amount"
          dataIndex="totalAmount"
          key="totalAmount"
        />
        <Column
          title="Action"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <Link to={`/salarydetails/${record.id}`}>Details</Link>
              {user.role == "admin" && (
                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => confirmDelete(record.id)}
                  size="small"
                >
                  Delete
                </Button>
              )}
            </Space>
          )}
        />
      </Table>
      <Modal
        title="Confirmation"
        visible={showDelete}
        onOk={handleDelete}
        okText="Yes"
        okButtonProps={{ loading: loading }}
        onCancel={() => setShowDelete(false)}
        cancelButtonProps={{ disabled: true }}
      >
        <p>
          <InfoCircleOutlined twoToneColor="#eb2f96" /> Are you sure you want to
          delete this Salary
        </p>
      </Modal>
    </>
  );
}
